/* __next_internal_client_entry_do_not_use__ default auto */ import useControlled from '@mui/utils/useControlled';
export default useControlled;
